import React, { useState, Fragment } from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import './DeclineModalComponent.css';
import reasonTitaleImage from '../../assets/images/reasonmodal.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
// import xIcon from '../../assets/images/xmark.svg'
import reasonIcon from '../../assets/images/bulb 1.svg'
import { useDispatch } from 'react-redux';
import { deleteOrderById, fetchOrders } from '../../redux/orderSlice';
import { getDate } from '../../helpers/helperFunction';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiPaper-root': {
        borderRadius: theme.spacing(2), // To adjust the modal borderRadius
    },
}));

const ReasonModalComponent = ({ forModule, reasonData, header = 'Cancellation Reason', status = 'Cancelled'}) => {
    const [open, setOpen] = React.useState(false);
    const [reasonText, setReasonText] = useState('');
    const dispatch = useDispatch();
    let reason, date, icon;
    if(status === 'Cancelled') {
        reason = reasonData.cancellationReason;
        date = getDate(reasonData.cancellationDate);
    } else if(status === 'Short Closed') {
        status = 'Short Close'
        reason = reasonData.shortClosedReason;
        date = getDate(reasonData.shortClosedDate);
    }

    const handleTextChange = (e) => {
        setReasonText(e.target.value);
    };

    const handleSubmit = () => {
        // console.log('Text submitted:', reasonText);
        const queryParams = {
            orderId: orderId
        }
        dispatch(deleteOrderById(queryParams)).then(() => {
            const queryParams = {
                type: 'outgoing',
                searchText: '',
                fromDate: '',
                toDate: '',
                pageSize: 12,
                pageNumber: 1,
            };
            dispatch(fetchOrders(queryParams))
        });

        handleClose();
    };

    const handleClickOpen = () => {
        setOpen(true);
        // onOpen()
    };
    const handleClose = () => {
        setOpen(false);
        // onClose()
    };
    // console.log('>>> :: Reasonn :: <<<', forModule, reasonData)

    return (
        <div>
            <Fragment >

                <button className="icon-clay delete" onClick={handleClickOpen}
              title="Reason"
                
                >
                    <span className="inner-clay color-red"> <img src={reasonIcon} alt="Reason" /></span>
                </button>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    className='shipmentDeclineModalBody'

                >
                    <DialogTitle sx={{ m: 0, p: "0px 39px " }} id="customized-dialog-title">
                        {/* Modal title */}
                        <div className='modalImagediv'>
                            <img
                                className='modalImage'
                                src={reasonTitaleImage}
                            />
                            <h4 className='headingForDeclineShipmentModal'> {header} {forModule} </h4>
                        </div>
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                            backgroundColor: "white",
                            height: "7%",
                            width: "6%",
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>

                        <Card variant="outlined">
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom>
                                    status
                                </Typography>
                                <Typography variant="body2" component="p">
                                    {status}

                                </Typography>
                                <Typography color="textSecondary" gutterBottom>
                                    Reason
                                </Typography>
                                <Typography variant="body2" component="p">
                                    {/* {reasonData.cancellationReason} */}
                                    {reason}
                                </Typography>

                                <Typography color="textSecondary" gutterBottom>
                                    Date
                                </Typography>
                                <Typography variant="body2" component="p">
                                {/* {getDate(reasonData.cancellationDate)} */}
                                {date}

                                    {/* {rejectedDate} */}
                                </Typography>
                            </CardContent>
                        </Card>
                    </DialogContent>

                </BootstrapDialog>
            </Fragment>
        </div>
    );
}
export default ReasonModalComponent